"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RequestError;

/*
export default class RequestError extends Error {
  constructor(response) {
    super(response.url + " " + response.status);
    this.response = response;
  }
}
*/
function RequestError(response) {
  this.name = "RequestError";
  this.response = response;
  this.message = response.url + " " + response.status;
  this.stack = new Error().stack;
}

RequestError.prototype = new Error(); // <-- remove this if you do not want RequestError to be instanceof Error